// Should stay in sync with instanceTrends.mjs

const INSTANCE_TRENDS = {
  STRENGTH: 0,
  CHALLENGE: 1,
  NEUTRAL: 2
};

export default INSTANCE_TRENDS;
